import { render, staticRenderFns } from "./ScoresTable.vue?vue&type=template&id=d80c7a08&scoped=true"
import script from "./ScoresTable.vue?vue&type=script&lang=js"
export * from "./ScoresTable.vue?vue&type=script&lang=js"
import style0 from "./ScoresTable.vue?vue&type=style&index=0&id=d80c7a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80c7a08",
  null
  
)

export default component.exports